import { LayoutGrid, List } from 'lucide-react';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import type { Vue } from '../preferences/vueStorage.js';
import styles from './BasculeVue.module.css';

/** Sélecteur Liste / Cartes : deux boutons à bascule, un seul pressé à la fois. */
export function BasculeVue({
  vue,
  onChange,
}: {
  vue: Vue;
  onChange: (vue: Vue) => void;
}): JSX.Element {
  const { t } = useTranslation(['regie']);
  const options: { valeur: Vue; icone: JSX.Element }[] = [
    { valeur: 'liste', icone: <List size={16} strokeWidth={1.5} aria-hidden /> },
    { valeur: 'cartes', icone: <LayoutGrid size={16} strokeWidth={1.5} aria-hidden /> },
  ];
  return (
    <div className={styles.bascule} role="group" aria-label={t('regie:commun.vue.libelle')}>
      {options.map(({ valeur, icone }) => (
        <button
          key={valeur}
          type="button"
          className={styles.bouton}
          aria-pressed={vue === valeur}
          title={t(`regie:commun.vue.${valeur}`)}
          onClick={() => onChange(valeur)}
        >
          {icone}
          <span className={styles.texte}>{t(`regie:commun.vue.${valeur}`)}</span>
        </button>
      ))}
    </div>
  );
}
